module.exports = __webpack_public_path__ + "static/media/portfolio9-6.ce37bdc3.png";